import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderedTeam = _resolveComponent("BorderedTeam")!

  return (_openBlock(), _createBlock(_component_BorderedTeam, {
    src: _ctx.team.picture?.pictureUrl,
    teamName: _ctx.team.name,
    hideAvatar: _ctx.team.hideAvatar,
    class: _normalizeClass({ 'is-muted': _ctx.teamIsDeleted }),
    isFull: _ctx.isFull
  }, null, 8, ["src", "teamName", "hideAvatar", "class", "isFull"]))
}